export default class StopEvent {
  constructor() {
    'ngInject';

    this.restrict = 'A';
  }

  link($scope, element, attrs) {
    if (attrs && attrs.stopEvent) {
      element.bind(attrs.stopEvent, (e) => {
        // e.stopPropagation();
        e.stopImmediatePropagation();
      });
    }
  }

  static directiveFactory() {
    'ngInject';

    return new StopEvent();
  }
}



// WEBPACK FOOTER //
// ./common/directives/stop-event.js